import React from 'react';
import proptypes from 'prop-types';
import { Checkmark } from '@one-thd/sui-icons';

const { number, oneOfType, string } = proptypes;

export const AisleBayInventory = ({ aisleBayInventory }) => {
  return (
    <span className="sui-flex sui-items-center sui-fill-success-strong sui-text-success sui-mr-2">
      <Checkmark color="inherit" size="small" />
      <span className="sui-ml-1">
        {aisleBayInventory}
      </span>
    </span>
  );
};

AisleBayInventory.propTypes = {
  aisleBayInventory: oneOfType([string, number]).isRequired
};
